import React from "react";
import {
  useStripe,
  useElements,
  PaymentElement
} from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import clientPropType from "../../../prop-types/client";
import { Button, ButtonContainer, Spinner } from "../../../commons/elements";

const propTypes = {
  eventId: PropTypes.string.isRequired,
  shortName: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  productSummary: PropTypes.object.isRequired,
  client: clientPropType.isRequired,
  metadata: PropTypes.object,
  user: PropTypes.object.isRequired,
  purchase: PropTypes.shape({
    isSubmitting: PropTypes.bool
  }).isRequired,
  submitPlayerPurchaseStripe: PropTypes.func.isRequired,
  loadingState: PropTypes.shape({
    clearState: PropTypes.func.isRequired,
    addHostedFieldCount: PropTypes.func.isRequired,
    notifyHostedFieldLoadComplete: PropTypes.func.isRequired,
    hostedFieldsLoadingProgress: PropTypes.shape({
      inProgress: PropTypes.func
    }).isRequired
  }).isRequired
};
function StripeForm(props) {
  const {
    productSummary,
    client,
    eventId,
    history,
    location,
    shortName,
    user,
    purchase,
    submitPlayerPurchaseStripe,
    loadingState,
    metadata
  } = props;
  const stripe = useStripe();
  const elements = useElements();

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    submitPlayerPurchaseStripe({
      productSummary,
      client,
      eventId,
      history,
      location,
      shortName,
      user,
      loadingState,
      metadata,
      elements,
      stripe
    });
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <PaymentElement />
        {purchase.isSubmitting && (
          <div id="cred-card-form-spinner" className="w-100 h-100 d-flex">
            <Spinner />
          </div>
        )}
        {!purchase.isSubmitting && (
          <ButtonContainer>
            <Button
              className="stripeButton"
              type="submit"
              disabled={!stripe || purchase.isSubmitting}
              label="Submit"
            />
          </ButtonContainer>
        )}
      </form>
    </div>
  );
}

const mapStateToProps = (state) => ({
  client: state.client.client
});

StripeForm.propTypes = propTypes;

export default connect(mapStateToProps)(StripeForm);
